import ErrorComponent from "./ErrorComponent.vue";
import SuccessComponent from "./SuccessComponent.vue";
const generatedTypes= new Map();
generatedTypes.set('ErrorComponent',ErrorComponent);
generatedTypes.set('SuccessComponent',SuccessComponent);
export default generatedTypes